import { Component } from '@angular/core';
import { AEmptyBasePage } from '../empty.base.page';

@Component({
    selector: 'app-empty-user',
    templateUrl: '../empty.base.page.html',
    styleUrls: ['../empty.base.page.css']
})
export class EmptyUserPage extends AEmptyBasePage {
    constructor() {
        super();
        this.pageTitleKey = '@@UserManagementPageTitle';
        this.pageDescriptionKey = '@@UserManagementPageDescription';
        this.settingItems = [
            {
                icon: 'pi pi-user',
                titleKey: '@@UserManagement',
                descriptionKey: '@@UserManagementDesc',
                link: '/settings/userCont/user'
            },
            {
                icon: 'pi pi-users',
                titleKey: '@@GroupManagement',
                descriptionKey: '@@GroupManagementDesc',
                link: '/settings/userCont/groups'
            },
            {
                icon: 'pi pi-shield',
                titleKey: '@@RoleManagement',
                descriptionKey: '@@RoleManagementDesc',
                link: '/settings/userCont/roles/role-overview'
            },
            {
                icon: 'pi pi-key',
                titleKey: '@@APIKeys',
                descriptionKey: '@@APIKeysDesc',
                link: '/settings/userCont/apikeys'
            }
        ];
    }
}
